import { transports, UserManager } from "@albelli/oidc";
import { vendor } from "helpers/vendorHelper";
import { parseJwt } from "./../helpers/parseJwt";
import { getAppConfig } from "./configService";

function createOidcManager() {
  const config = getAppConfig();
  if (!config) {
    throw new Error("Cannot create Oidc UserManager. Config is not loaded yet.");
  }

  return new UserManager({
    authority: config.Auth.Authority,
    client_type: "AuthorizationCodeWithProofKey",
    client_id: config.Auth.ClientID,
    client_secret: config.Auth.ClientSecret,
    scope: config.Auth.Scopes,
    transport: new transports.RedirectTransport({ redirect_uri: window.location.origin }),
    extra: {
      theme: vendor,
      acr_values: vendor === "fotoknudsen.no" ? "idp:fotoknudsen" : "idp:albelli"
    }
  });
}

function getOidcManager() {
  if (!window.oidcManager) {
    window.oidcManager = oidc.createOidcManager();
  }

  return window.oidcManager;
}

async function getCurrentUserJwt() {
  const oidcManager = oidc.getOidcManager();
  const token = await oidcManager.getAccessToken();
  return parseJwt(token);
}

async function getCurrentUserEmail() {
  const jwt = await oidc.getCurrentUserJwt();
  return jwt.email;
}

export const oidc = {
  createOidcManager,
  getOidcManager,
  getCurrentUserJwt,
  getCurrentUserEmail
};
